import React from "react";
import { Input } from "@my-scoot/component-library-legacy";
import NoOfferingsFound from "./NoOfferingsFound";

const OfferingSearchHeader = ({
  searchQuery,
  setSearchQuery,
  debouncedSearchQuery,
  offeringsLoading,
  infiniteOptions,
}) => {
  return (
    <div
      style={{ padding: "8px 12px" }}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Input
        placeholder="Search offerings..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        fullWidth
        size="small"
        autoFocus
      />

      <NoOfferingsFound
        searchQuery={debouncedSearchQuery}
        loading={offeringsLoading}
        options={infiniteOptions}
      />
    </div>
  );
};

export default OfferingSearchHeader;
